import React from 'react';
import './styles/index.css'
import GMWhite from './assets/images/GMWhite.png'

/**
 * The Header class for the SPS2 Info FrontEnd
 *
 * @author Ethan Jones
 */
export default class Header extends React.Component {

    /**
     * Constructor for the Header Class
     * @param props
     */
    constructor(props) {
        super(props);
    }

    state = {
        HeaderInstructions: "To obtain the latest electronic controller calibration information for your vehicle, enter the \
                vehicle's 17 character Vehicle Identification Number (VIN) and select 'Get CAL ID'. To obtain the Calibration \
                Verification Number (CVN) for any calibration part number, enter the part number of the calibration ID and select \
                'Get CVN'. You will be required to answer a captcha on your first search, afterwards you will be prompted to answer \
                every 5th search".split('.'),
    }

    /**
     * Render method of the header class, which displays the contents of the header class to the front end
     * @returns {*}
     */
    render() {

        return (
            <React.Fragment>
                <div style={{paddingBottom: "10px"}}>
                    <header className={"spsheader"}>
                        <img src={GMWhite} style={{position: "relative", left: 28}} alt={""}/>
                    </header>
                    <header>
                        <h2 className={"spsinformation"}>SPS Information</h2>
                        {this.state.HeaderInstructions.map(instruction => (
                            <p className={"spsinfotext"}>{instruction}</p>
                        ))}
                    </header>
                </div>
            </React.Fragment>
        )
    }
}